import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Stack, Text, TextInput } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import {
  getGeneralPreferenceDefaults,
  toggleValue,
} from "../generalPreferenceForm";

const SMS_NOTIFICATIONS = [
  "Commande bloquée",
  "Design à valider",
  "Empreinte à refaire",
  "Expéditions",
];

export const NotificationPreferences = withForm({
  defaultValues: getGeneralPreferenceDefaults(undefined),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "mobileNumber",
      "smsNotifications",
    ]);

    return (
      <SaveableCard
        title="Notifications"
        description="Alertes envoyées par SMS"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <>
            <Text variant="strong">Numéro de mobile</Text>
            <form.Field name="mobileNumber">
              {field => (
                <TextInput
                  value={field.state.value}
                  onChange={event => field.handleChange(event.target.value)}
                  onBlur={field.handleBlur}
                />
              )}
            </form.Field>
          </>
          <Group gap="s1">
            <Text variant="strong">Recevoir un SMS pour</Text>•
            <Text variant="strong" fw="400">
              le détail reste consultable dans l&lsquo;app
            </Text>
          </Group>
          <form.Field name="smsNotifications">
            {field => (
              <Group>
                {SMS_NOTIFICATIONS.map(notification => (
                  <ButtonCheckbox
                    key={notification}
                    id={notification}
                    isActive={field.state.value.includes(notification)}
                    onClick={() =>
                      field.handleChange(values =>
                        toggleValue(values, notification)
                      )
                    }
                  >
                    {notification}
                  </ButtonCheckbox>
                ))}
              </Group>
            )}
          </form.Field>
        </Stack>
      </SaveableCard>
    );
  },
});
